import { Text } from '@components/ui';
import Grid from '@mui/material/Grid';
import type { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { TextValidator } from 'react-material-ui-form-validator';

interface UpdateHirePersonalFieldsProps {
  name: string | undefined;
  email: string | undefined;
  handleChangeObject: (event: ChangeEvent<HTMLInputElement>) => void;
}

export function UpdateHirePersonalFields({
  name,
  email,
  handleChangeObject,
}: UpdateHirePersonalFieldsProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <Text
        variant="label"
        sx={{
          mt: 6,
          mb: 1.25,
          display: 'block',
          textTransform: 'uppercase',
          fontWeight: 700,
        }}
      >
        {t('hire.personal')}
      </Text>
      <Grid
        container
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        spacing={2}
        style={{ display: 'flex' }}
      >
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TextValidator
            sx={{
              width: '100%',
              borderRadius: '5px',
              backgroundColor: 'white',
              '& fieldset': { border: 'none' },
            }}
            label={t('hire.updateHire.yourName')}
            onChange={(event) => handleChangeObject(event)}
            type="text"
            name="name"
            value={name || ''}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TextValidator
            sx={{
              width: '100%',
              borderRadius: '5px',
              backgroundColor: 'white',
              '& fieldset': { border: 'none' },
            }}
            label={t('hire.updateHire.yourEmail')}
            onChange={(event) => handleChangeObject(event)}
            type="email"
            name="email"
            value={email || ''}
          />
        </Grid>
      </Grid>
    </>
  );
}
